import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Shop-scoped link helper for the multi-location routing model.
 *
 * Multi-shop orgs route under `/:shopId/...`; single-shop orgs keep the flat
 * routes unchanged (no `:shopId` param). `shopPath('/orders')` therefore
 * returns `/{shopId}/orders` when shop-scoped and `/orders` otherwise, so the
 * same nav links work in both modes without per-call branching.
 *
 * Settings is shop-scoped like every other page (NEA-5723), so its links go
 * through this too. Only the genuinely global routes (login, logout,
 * impersonate, no-shops, sign-up, design-guidelines) must NOT be passed
 * through this — link to them directly.
 */
export function useShopPath() {
	const { shopId } = useParams();

	const shopPath = useCallback(
		(to) => {
			if (!shopId || typeof to !== 'string' || !to.startsWith('/')) return to;
			return to === '/' ? `/${shopId}` : `/${shopId}${to}`;
		},
		[shopId]
	);

	return { shopId, isShopScoped: Boolean(shopId), shopPath };
}
